export const valoresExibidosOffCanvasListagemAquisicoes: Record<
  string,
  string
> = {
  id: 'ID',
  tipoAquisicao: 'Tipo de Aquisição',
  status: 'Status',
  componenteAf: 'Comp. AF',
  denominacaoKit: 'Denominação/Kit',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersListagemAquisicoes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo de Aquisição', width: 4, key: 'tipoAquisicao' },
  { text: 'Status', width: 4, key: 'status' },
  { text: 'Comp. AF', width: 4, key: 'componenteAf' },
  { text: 'Denominação/Kit', width: 25, key: 'denominacaoKit' },
];

export const tableAquisicoes = [
  {
    id: 1,
    tipoAquisicao: 'Processo Licitatório',
    status: 'Em Processo',
    unidadeDAF: 'CGCEAF',
    denominacaoKit: 'Abatacepte',
    valorTotal: 750000.0,
  },
];

export const fieldObjectListagemAquisicoes = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export type AquisicoesTableRow = {
  id: string | number;
  tipoAquisicao: string;
  status: string;
  componenteAf: string;
  modalidade: string;
  submodalidade: string;
  denominacaoKit: string;
  denominacaoKitBool: string;
  [key: string]: any;
};
